module.exports = __webpack_public_path__ + "img/44-r.adc63435.png";